import { AxiosInstance } from "axios";
import { IMessage } from "../models/Messages";
import { makeFormData } from "../components/utils/formData";
import { BaseHTTP } from "./base.http";


export class MessagesApi {

  private http !: AxiosInstance

  constructor() {
    this.http = BaseHTTP.getInstance().http
  }

  async sendMessage(message: IMessage, files: File[]) {
    const selectedBusiness = localStorage.getItem('selectedBusiness')
    const companyId = selectedBusiness ? JSON.parse(selectedBusiness).id : null
    const messageData = makeFormData({ ...message, files, companyId })
    const messageResponse = await this.http.post(
      'v1/messages',
      messageData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )

    return messageResponse.data
  }

  async deleteMessage(messageId: string) {
    const deleteResponse = await this.http.delete(`v1/messages/${messageId}`);

    return deleteResponse.data;
  }
}

export default new MessagesApi()
